// extracted by mini-css-extract-plugin
module.exports = {"PSCLayout":"styles_PSCLayout__H_mFr","card":"styles_card__16aV8"};